var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLaboratoryIconHaidi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 16 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6FA9FF",
  d: "M4 2.957c0-.554.447-1 1-1h3c.553 0 1 .446 1 1v7c0 .553-.447 1-1 1 0 .553-.447 1-1 1H6c-.553 0-1-.447-1-1-.553 0-1-.447-1-1v-7Zm12 8a5.979 5.979 0 0 1-1.528 4H15a.999.999 0 1 1 0 2H1a.999.999 0 1 1 0-2h9a4 4 0 1 0 0-8v-2c3.313 0 6 2.687 6 6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#154FA6",
  d: "M6 .957c-.553 0-1 .446-1 1h3c0-.554-.447-1-1-1H6Zm-2.5 12c-.275 0-.5.224-.5.5 0 .274.225.5.5.5h6c.275 0 .5-.226.5-.5 0-.276-.225-.5-.5-.5h-6Z"
})));
export default SvgLaboratoryIconHaidi;